import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, zIndex, getResetByTag, utilityStyles } from '../../../../styles';
import StyledModalHeaderInner from './styles/modal.header.inner.styles';
import StyledModalHeaderTitle from './styles/modal.header.title.styles';
import StyledModalHeaderChildren from './styles/modal.header.children.styles';
import StyledVehicleImage from './../../../vehicle-image/vehicle-image.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("background-color:", colors.white, ";color:", colors.white, ";flex-shrink:0;padding:", rem(0, 0, 0, 16), ";position:relative;z-index:", zIndex.zIndex_2, ";", StyledModalHeaderInner, "{>", StyledModalHeaderChildren, "{>", StyledVehicleImage, "{align-self:flex-end;height:0;&>*{top:", rem(48), ";transform:translateY(-100%);&>:nth-of-type(2){position:relative;}}}}", StyledModalHeaderTitle, "{min-height:", rem(24), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var hasBorderStyles = function hasBorderStyles(_ref) {
  var hasBorder = _ref.hasBorder,
    isInverse = _ref.isInverse;
  if (hasBorder) {
    return /*#__PURE__*/css(StyledModalHeaderInner, "{border-bottom:", isInverse ? "".concat(rem(1), " solid ").concat(colors.navy_400) : "".concat(rem(1), " solid ").concat(colors.coolGray_500), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasBorderStyles;"));
  }
};
var isFlushPaddingStyles = function isFlushPaddingStyles(_ref2) {
  var isFlushPadding = _ref2.isFlushPadding;
  if (isFlushPadding) {
    return /*#__PURE__*/css("padding:0;", StyledModalHeaderInner, "{padding:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:isFlushPaddingStyles;"));
  }
};
var isInverseStyles = function isInverseStyles(_ref3) {
  var isInverse = _ref3.isInverse;
  if (isInverse) {
    return /*#__PURE__*/css("background:", colors.navy_500, " no-repeat top right;padding:", rem(0, 16), ";", StyledModalHeaderInner, "{color:", colors.white, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:isInverseStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledModalHeader = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1xyskz30"
} : {
  target: "e1xyskz30",
  label: "StyledModalHeader"
})(resetStyles, defaultStyles, hasBorderStyles, isFlushPaddingStyles, isInverseStyles, utilityStyles);
export default StyledModalHeader;